import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {DialogService} from "ng2-bootstrap-modal";
import {SendSignalService} from "../../../_services/send-signal.service";
import {Observable} from "rxjs/Observable";
import {LineBotService} from "../../../_services/line-bot.service";
import {AuthenticationService} from "../../../_services/authentication.service";
import {AppConfigs} from "../../../app.config";
import * as moment from 'moment-timezone';
import {AlertBoxComponent} from "../../../_common/alert-box/alert-box.component";

declare var $: any;

@Component({
    selector: 'app-coin-send-price-user',
    templateUrl: './coin-send-price-user.component.html',
    styleUrls: ['../send-signal-event.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class CoinSendPriceUserComponent implements AfterViewInit, OnInit {
    lineBotAll: any[] = [];
    constantSendSignal: any;
    currencyType: any;
    hourListForUser: any[] = [];
    isRoleUser: any;
    lineBotID: any;
    moduleID: any;
    listCoinUser: any [];
    listCoinSelected: any [] = [];
    selectedCurrency: string;
    selectedSendTime: string;
    selectedIsActive: string = '1';
    codeFunction: Observable<any[]>;
    listFunctionsUser: any[];
    listCoinUserSelectedClone: any = [];
    listCoinUserClone: any = [];
    strErrorListCoin: string = '';
    isFromUserValidate: boolean = false;
    loading = false;
    model: any = {};
    sendSignalEventIDByUser: any = null;
    isActiveDefault: any = '1';

    constructor(private dialogService: DialogService,
                private sendSignalService: SendSignalService,
                private lineBotService: LineBotService,
                private authenticationService: AuthenticationService
    ) {
        this.isRoleUser = this.authenticationService.checkRoleUser();
        this.constantSendSignal = this.sendSignalService.getConstantSendSignal();
        this.codeFunction = this.sendSignalService.postFunctionByUser();
    }

    ngOnInit() {
        this.renderFunctionPriceUser();
    }

    renderFunctionPriceUser() {
        let self = this;
        this.codeFunction.subscribe(resFunctions => {
            self.listFunctionsUser = resFunctions;
            self.lineBotService.getLineBot().subscribe(resLineBotAll => {
                if (resLineBotAll.length && Object.keys(resFunctions).length) {
                    Object.keys(resFunctions).map((lineBotID) => {
                        let objLineBotID = resLineBotAll.find((obj) => {
                            return obj.id == lineBotID
                        });
                        if (resFunctions.hasOwnProperty(lineBotID) && resFunctions[lineBotID].hasOwnProperty('listCoinUser') && objLineBotID) {
                            self.lineBotAll.push({
                                id: objLineBotID.id,
                                linebot_channel_name: objLineBotID.linebot_channel_name
                            })
                        }
                    });

                    self.lineBotID = self.lineBotID || (self.lineBotAll.length ? self.lineBotAll[0].id : resLineBotAll[0].id);

                    let listCoinUser = self.lineBotAll.length ? resFunctions[self.lineBotID]['listCoinUser'] : [];
                    let sendSignalEventIDByUser = self.lineBotAll.length && resFunctions[self.lineBotID].hasOwnProperty('listCoinUserSelected')
                        ? resFunctions[self.lineBotID]['listCoinUserSelected']['sendSignalEventIDByUser'] : null;
                    let listDataSelected = self.lineBotAll.length && resFunctions[self.lineBotID].hasOwnProperty('listCoinUserSelected') ? resFunctions[self.lineBotID]['listCoinUserSelected'] : [];
                    let moduleID = self.lineBotAll.length && resFunctions[self.lineBotID].hasOwnProperty('listCoinUserSelected')
                        ? resFunctions[self.lineBotID]['listCoinUserSelected']['moduleID'] : null;


                    self.listCoinUserClone = listCoinUser;
                    self.sendSignalEventIDByUser = sendSignalEventIDByUser;
                    self.moduleID = moduleID;
                    self.listCoinUserSelectedClone = listDataSelected.hasOwnProperty('listCoinSelected') ? listDataSelected.listCoinSelected : [];

                    self.renderDataFunctionByUser(listCoinUser, listDataSelected, () => {
                        self.sendSignalService.getConstantSendSignal().subscribe(resConstantSendSignal => {
                            self.constantSendSignal = resConstantSendSignal.constants;
                            self.currencyType = Object.keys(resConstantSendSignal.constants.currencyType).map((key) => {
                                return {value: key, name: resConstantSendSignal.constants.currencyType[key]};
                            });
                            // rank Hour in [1 - 23]
                            let rankHour = (0 < parseInt(resConstantSendSignal.constants.hoursRanksForUser) && parseInt(resConstantSendSignal.constants.hoursRanksForUser) < 24)
                                ? parseInt(resConstantSendSignal.constants.hoursRanksForUser)
                                : 1;
                            let rankCeilHour = Math.ceil(24 / rankHour);
                            self.hourListForUser = new Array(rankCeilHour).fill('').map((x, i) => {
                                let addString = (i * rankHour < 10) ? '0' : '';
                                return {
                                    value: (addString + (i * rankHour) + ':00'),
                                    txtHtml: (addString + (i * rankHour) + ' : 00')
                                };
                            });
                        });
                    });
                }
            });
        });
    }

    ngAfterViewInit() {
        let self = this;
        setTimeout(() => {
            self.checkBoxAllUser();
        });
    }

    checkBoxAllUser() {
        setTimeout(() => {
            $('#check-all-user-coin').prop('checked', (this.listCoinUserClone.length == this.listCoinUserSelectedClone.length ? 'checked' : ''));
        });
    }

    checkAllListUser(event: any) {
        let self = this;
        self.listCoinUserSelectedClone = [];
        this.listCoinUserClone.map((elem, index) => {
            if (event.target.checked) {
                self.listCoinUserSelectedClone.push(+elem.coin_id);
                $('#check-box-user-' + elem.coin_id).attr('checked', 'checked');
            } else {
                $('#check-box-user-' + elem.coin_id).attr('checked', '');
            }
        });
        this.customValidateFromUser();
    }

    toggleSelectionUser(event: any) {
        let value = event.target.dataset.value;
        if (this.checkedBoxUser(+value)) {
            // Is currently selected
            this.listCoinUserSelectedClone.splice(this.listCoinUserSelectedClone.indexOf(+value), 1);
        } else {
            // Is newly selected
            this.listCoinUserSelectedClone.push(+value);
        }

        this.checkBoxAllUser();
        this.customValidateFromUser();
    }

    onChangeLineBotForUser(event: any) {
        let self = this;

        self.lineBotID = event.target.value;
        let listCoinUser = self.lineBotAll.length ? self.listFunctionsUser[self.lineBotID]['listCoinUser'] : [];
        let listDataSelected = self.lineBotAll.length && self.listFunctionsUser[self.lineBotID].hasOwnProperty('listCoinUserSelected')
            ? self.listFunctionsUser[self.lineBotID]['listCoinUserSelected']
            : [];

        let sendSignalEventIDByUser = self.lineBotAll.length && self.listFunctionsUser[self.lineBotID].hasOwnProperty('listCoinUserSelected')
            ? self.listFunctionsUser[self.lineBotID]['listCoinUserSelected']['sendSignalEventIDByUser'] : null;

        let moduleID = self.lineBotAll.length && self.listFunctionsUser[self.lineBotID].hasOwnProperty('listCoinUserSelected')
            ? self.listFunctionsUser[self.lineBotID]['listCoinUserSelected']['moduleID'] : null;

        self.listCoinUserClone = listCoinUser;
        self.sendSignalEventIDByUser = sendSignalEventIDByUser;
        self.moduleID = moduleID;
        self.listCoinUserSelectedClone = listDataSelected.hasOwnProperty('listCoinSelected') ? listDataSelected.listCoinSelected : [];

        self.strErrorListCoin = self.listCoinUserSelectedClone.length ? '' : 'コインを選択一覧が空ではいけません。';

        self.renderDataFunctionByUser(listCoinUser, listDataSelected, () => {
        });
    }

    renderDataFunctionByUser(listCoinUser: any, dataSelected: any, callback) {
        this.listCoinUser = listCoinUser;
        this.listCoinSelected = dataSelected.hasOwnProperty('listCoinSelected') ? dataSelected.listCoinSelected : [];
        this.selectedCurrency = dataSelected.hasOwnProperty('selectedCurrency') ? dataSelected.selectedCurrency : 'usd';
        this.selectedSendTime = dataSelected.hasOwnProperty('selectedSendTime') ? dataSelected.selectedSendTime + '' : '';
        this.selectedIsActive = dataSelected.hasOwnProperty('selectedIsActive') ? dataSelected.selectedIsActive + '' : this.isActiveDefault;

        this.checkBoxAllUser();
        this.customValidateFromUser();
        callback();
    }

    checkedBoxUser(value) {
        return this.listCoinUserSelectedClone.length
            ? this.listCoinUserSelectedClone.indexOf(+value) != -1
            : false;
    }

    changeValActiveEventUser(event: any) {
        this.selectedIsActive = event.target.value != this.constantSendSignal.statusEvent.stopped
            ? this.constantSendSignal.statusEvent.stopped
            : this.constantSendSignal.statusEvent.active;
    }

    customValidateFromUser() {
        let self = this;
        this.strErrorListCoin = this.listCoinUserSelectedClone.length ? '' : 'コインを選択一覧が空ではいけません。';
        let listCoinIDUser = this.listCoinUserSelectedClone.length;
        let cusFromValidate = false;

        cusFromValidate = (!cusFromValidate && listCoinIDUser && self.strErrorListCoin.length == 0) ? true : false;

        self.isFromUserValidate = cusFromValidate;
        return self.isFromUserValidate;
    }

    getDataModelForUser(callback: any) {
        let self = this;
        let timeSend = $('#minute-cron-user :selected').val();
        let currencyUser = $('#currency-user :selected').val();

        // Set model
        self.model.lineBotID = +this.lineBotID;
        self.model.moduleID = this.moduleID;
        self.model.setTimeSend = moment().tz(AppConfigs.TIME_ZONE).format('YYYY-MM-DD') + ' ' + timeSend + ':00';// minute-cron-user
        self.model.currency = currencyUser;// currency-user
        self.model.isActive = this.selectedIsActive;
        self.model.listCoinEventForUser = this.getListCheckedCoin().join(',');
        self.model.sendSignalEventIDByUser = this.sendSignalEventIDByUser;

        callback(self.model);
    }

    updateOrCreateEventUser() {
        let self = this;
        self.loading = true;
        if (self.customValidateFromUser()) {
            self.getDataModelForUser(model => {
                self.sendSignalService.postFunctionUpdateOrCreateByUser(model).subscribe(resData => {
                    self.loading = false;
                    self.isFromUserValidate = false;
                    if (resData.hasOwnProperty('result') && resData.result == false) {
                        if (resData.hasOwnProperty('type') && resData.type === '_FAIL_') {
                            if (resData.hasOwnProperty('error')) {
                                self.dialogService.addDialog(AlertBoxComponent, {message: resData.error}).subscribe((result) => {
                                });
                            }
                        }
                    }

                    self.lineBotAll = [];
                    self.renderFunctionPriceUser();
                }, error => {
                    self.isFromUserValidate = false;
                    location.reload();
                });
            });
        }
    }

    getListCheckedCoin() {
        return $.map($('#box-list-coin-user .checkbox'), (domElement, index) => {
            if ($(domElement).is(':checked')) {
                return $(domElement).val();
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/send-signal-event/coin-send-price-user/coin-send-price-user.component.ts